import { call, put } from 'redux-saga/effects';

import {
  removeFriendFromLocalList,
  setFriendRequestNotifications,
  setFriends,
  setLoadFriendsWaiting,
  setRemoveFriendMessage,
  setRemoveFriendSuccess,
  setRemoveFriendWaiting,
  setResolveFriendRequestMessage,
  setResolveFriendRequestSuccess,
  setResolveFriendRequestWaiting,
  setSendFriendRequestMessage,
  setSendFriendRequestSuccess,
  setSendFriendRequestWaiting,
  setTotalFriendsCount,
} from '../actions/MyFriendsActions';
import Services from '../services/index';

export function* sendFriendsRequestSagas(action) {
  try {
    yield put(setSendFriendRequestWaiting(true));

    yield call(Services.MyFriendsService.sendFriendRequest, action.email);

    yield put(
      setSendFriendRequestMessage({
        type: 'success',
        text: 'Request sent successfully!',
      }),
    );
    yield put(setSendFriendRequestSuccess(true));

    yield put(setSendFriendRequestWaiting(false));
  } catch (err) {
    if (err.response.data.error) {
      yield put(
        setSendFriendRequestMessage({
          type: 'error',
          text: err.response.data.error,
        }),
      );
    } else {
      yield put(
        setSendFriendRequestMessage({ type: 'error', text: err.response.data }),
      );
    }
    yield put(setSendFriendRequestWaiting(false));
    yield put(setSendFriendRequestSuccess(false));
  }
}

export function* laodFriendsSagas(action) {
  try {
    yield put(setLoadFriendsWaiting(true));

    const response = yield call(
      Services.MyFriendsService.loadFriends,
      action.skip,
      action.limit,
    );

    yield put(setFriends(response.friends));
    yield put(setTotalFriendsCount(response.count));
    yield put(setLoadFriendsWaiting(false));
  } catch (err) {
    yield put(setLoadFriendsWaiting(false));
    yield put(setTotalFriendsCount(0));
    yield put(setFriends([]));
  }
}

export function* removeFriendSagas(action) {
  try {
    yield put(setRemoveFriendWaiting(true));

    const response = yield call(
      Services.MyFriendsService.removeFriend,
      action.friendId,
    );

    yield put(removeFriendFromLocalList(action.friendId));
    yield put(setTotalFriendsCount(response.count));

    yield put(setRemoveFriendSuccess(true));
    yield put(setRemoveFriendWaiting(false));
    yield put(
      setRemoveFriendMessage({
        type: 'success',
        text: 'Friend removed successfully',
      }),
    );
  } catch (err) {
    yield put(setRemoveFriendSuccess(false));
    yield put(setRemoveFriendWaiting(false));
    yield put(
      setRemoveFriendMessage({
        type: 'error',
        text: 'Oops! Something happend trying to remove your friend',
      }),
    );
  }
}

export function* resolveFriendRequestSagas(action) {
  try {
    yield put(setResolveFriendRequestWaiting(true));

    yield call(
      Services.MyFriendsService.updateFriendRequestStatus,
      action.id,
      action.status,
    );

    yield put(setResolveFriendRequestSuccess(true));
    yield put(setResolveFriendRequestWaiting(false));
  } catch (err) {
    yield put(setResolveFriendRequestWaiting(false));
    yield put(setResolveFriendRequestSuccess(false));
    yield put(
      setResolveFriendRequestMessage({
        type: 'error',
        text: 'Oops! something happend trying to resolve this friend request',
      }),
    );
  }
}

export function* getFriendRequestNotificationsSaga() {
  try {
    const response = yield call(
      Services.MyFriendsService.getFriendRequestNotifications,
    );
    yield put(setFriendRequestNotifications(response));
  } catch (err) {
    yield put(setFriendRequestNotifications([]));
  }
}
